import { useCallback } from 'react'

import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { CONFIG_REPORTING_SERVICES } from '@src/config/env'
import appData from '@src/quince-site-common/src/helpers/appData'
import useBearerFetch from './useBearerFetch'

const useReferralPoints = email => {
  const { fetchData, response } = useBearerFetch()

  const fetchReferrals = useCallback(() => {
    const isReferralApiSupported = appData.environmentType !== BUILD_ENVIRONMENTS.STAGE
    const url = `${CONFIG_REPORTING_SERVICES}/v2-referralEmails/referredCustomers?emailId=${email}`

    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
    return isReferralApiSupported && fetchData(url, options)
  }, [email, fetchData])

  return {
    fetchReferrals,
    successfulReferrals: response?.successfulReferrals,
    invitedReferrals: response?.invitedReferrals,
  }
}

export default useReferralPoints
